"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.type.target': 'Objetivo',
    'slotData.type.goal': 'Meta',
};
